"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyStageLabelsMap = void 0;
var coverage_api_1 = require("@newfront-insurance/coverage-api");
exports.policyStageLabelsMap = (_a = {},
    _a[coverage_api_1.PolicyStage.ACQUIRED] = 'Acquired',
    _a[coverage_api_1.PolicyStage.BOR] = 'BOR',
    _a[coverage_api_1.PolicyStage.RENEWAL] = 'Renewal',
    _a[coverage_api_1.PolicyStage.BOR_LOST] = 'BOR lost',
    _a[coverage_api_1.PolicyStage.HISTORICAL] = 'Historical',
    _a[coverage_api_1.PolicyStage.NEW] = 'New',
    _a[coverage_api_1.PolicyStage.NEW_BOR] = 'New BOR',
    _a[coverage_api_1.PolicyStage.NON_PAYMENT] = 'Non payment',
    _a[coverage_api_1.PolicyStage.OUTSIDE_CARRIER_APPETITE] = 'Outside carrier appetite',
    _a[coverage_api_1.PolicyStage.OUT_OF_BUSINESS] = 'Out of business',
    _a[coverage_api_1.PolicyStage.POOR_LOSS_HISTORY] = 'Poor loss history',
    _a[coverage_api_1.PolicyStage.REWRITTEN] = 'Rewritten',
    _a);
